module.exports = __webpack_public_path__ + "static/cocoa_cake_slika3-d2e08775ae429e5e42ff00a2572575f3.jpg";